import React, { FC, useEffect, useMemo, useCallback } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Typography, Theme } from '@mui/material'

import { useHistory, useParams } from 'react-router-dom'
import { TabsComponent } from '../../../components/Tabs'
import { tabList } from './tabList'
import { routes } from '../../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  topWrap: {
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingTop: theme.spacing(4),
    '& p': {
      display: 'none',
    },
  },
  title: {
    paddingTop: theme.spacing(2),
  },
}))

export const Rules: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const { tab } = useParams<{ tab?: string }>()

  const activeTab = useMemo(() => {
    const currentTab = tabList.find((t) => t.slug === tab)
    return currentTab?.slug || tabList[0]?.slug || ''
  }, [tab])

  useEffect(() => {
    if (tab !== activeTab && activeTab) {
      history.replace(`${routes.SETTINGS_RULES}/${activeTab}?page=1`)
    }
  }, [activeTab, tab, history])

  const handleTabChange = useCallback(
    (key: string) => {
      history.push(`${routes.SETTINGS_RULES}/${key}?page=1`)
    },
    [history],
  )

  return (
    <>
      <Grid container className={classes.topWrap}>
        <Typography variant="h1" className={classes.title}>
          Rules
        </Typography>
      </Grid>
      <TabsComponent tabList={tabList} activeTab={activeTab} onChangeTab={handleTabChange} />
    </>
  )
}
